import { CirclePlus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Dropzone } from '@/components/ui/dropzone'
import { Separator } from '@/components/ui/separator'

/** An empty list's add button, "or", and dropzone — the rosters' empty state, for any list. */
export function UploadBlankState({
  addLabel,
  onAdd,
  onFile,
  accept,
  isLoading = false,
  disabled = false,
}: {
  addLabel: string
  onAdd: () => void
  onFile: (file: File) => void
  accept?: string
  isLoading?: boolean
  disabled?: boolean
}) {
  return (
    <div className="mt-10 mb-10 flex w-full flex-col items-center justify-center gap-5">
      <Button onClick={onAdd} disabled={disabled || isLoading}>
        <CirclePlus />
        {addLabel}
      </Button>

      <div className="text-ink-400 flex items-center justify-center gap-2 text-sm">
        <Separator className="bg-ink-100 w-[100px]! shrink" /> or{' '}
        <Separator className="bg-ink-100 w-[100px]! shrink" />
      </div>

      <Dropzone
        onChange={(file) => file && onFile(file)}
        accept={accept}
        maxSizeMB={10}
        isLoading={isLoading}
        disabled={disabled || isLoading}
        key={String(isLoading)}
      />
    </div>
  )
}
